export default {
  getCsvOrderLine: (state) => state.csvOrderLine,
};
